import React from 'react';

import Item from './item';

export default function UnsplashItem({ authorLink, authorName, description, link, ...props }) {
  return (
    <Item {...props} title={description}>
      By&nbsp;
      <a href={authorLink} target="_blank" rel="noreferrer noopener">
        {authorName}
      </a>
      <br />
      on&nbsp;
      <a href={link} target="_blank" rel="noreferrer noopener">
        Unsplash
      </a>
    </Item>
  );
}

UnsplashItem.propTypes = {
  authorLink: React.PropTypes.string.isRequired,
  authorName: React.PropTypes.string.isRequired,
  description: React.PropTypes.string.isRequired,
  link: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/item-unsplash.jsx